<template>
  <v-card>
    <v-toolbar card color="white">
      <v-text-field
        v-model="localFilters.match"
        :placeholder="$t('action.buttons.search')"
        flat
        hide-details
        prepend-icon="search"
        solo
        @keyup.enter="$store.dispatch('typeSubscriptions/fetchList')"
      />
      <meta-button type="new" @click="$emit('form')" />
    </v-toolbar>
    <v-divider />
    <v-card-text class="pa-0">
      <v-data-table
        :items="formatedList"
        :headers="headers"
        :rows-per-page-items="[10, 25, 50]"
        :loading="loading"
        disable-initial-sort
        item-key="_id"
        :total-items="localPagination.totalItems"
        :pagination.sync="localPagination"
      >
        <template slot="items" slot-scope="props">
          <td class="text-xs-center px-0">
            <v-icon
              color="success"
              class="mr-1"
              @click="setOne(props.item._id)"
            >
              edit
            </v-icon>
            <v-icon color="error" @click="ifDelete(props.item._id)">
              delete
            </v-icon>
          </td>
          <td class="text-xs-center">
            <button-state :state="props.item.active" />
          </td>
          <td>{{ props.item.name }}</td>
          <td style="min-width: 200px">
            <template v-for="(oneType, index) in props.item.availableMatches">
              <v-chip :key="index + oneType" small color="primary" dark>
                {{ oneType }}
              </v-chip>
            </template>
          </td>
          <td style="min-width: 200px">
            <template v-for="(typePayment, index) in props.item.typePayment">
              <v-chip :key="index + typePayment" small color="primary" dark>
                {{
                  $t(
                    `fields.typeSubscriptions.typesPayment.${
                      typePayment.type.split('-')[0]
                    }`
                  )
                }}
                {{
                  country(typePayment.countryId)
                    ? `(${country(typePayment.countryId).text})`
                    : ''
                }}
                {{ typePayment.price | currency }}
              </v-chip>
            </template>
          </td>
          <td class="text-xs-center">
            {{
              props.item.storage
                | currency({
                  symbol: '',
                })
            }}
          </td>
          <td class="text-xs-center">
            {{ props.item.createdAt }}
          </td>
          <td class="text-xs-center">
            {{ props.item.createdBy }}
          </td>
          <td class="text-xs-center">
            <i
              class="icon material-icons cursor"
              @click="openUpdated(props.item._id)"
              >visibility</i
            >
          </td>
        </template>
      </v-data-table>
    </v-card-text>
    <dialog-delete
      :dialog.sync="dialogDelete"
      :loading="loading"
      @delete="_setDelete(idDelete)"
    />
  </v-card>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import DialogDelete from '@/components/widgets/dialog/DialogDelete'
import { apiAxios } from '@/helpers/api'

export default {
  name: 'TypeSubscriptionList',
  components: {
    DialogDelete,
  },
  data() {
    return {
      search: '',
      idDelete: '',
      dialogDelete: false,
      countriesList: [],
    }
  },
  watch: {
    'filters.match': {
      handler: function (/* val, oldVal */) {
        if (this.localPagination.page !== 1) this.localPagination.page = 1
        this.debounceFetch('typeSubscriptions')
      },
    },
    'localPagination.page': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('typeSubscriptions')
      },
    },
    'localPagination.rowsPerPage': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('typeSubscriptions')
      },
    },
    'localPagination.sortBy': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('typeSubscriptions')
      },
    },
    'localPagination.descending': {
      handler: function (/* val, oldVal */) {
        this.debounceFetch('typeSubscriptions')
      },
    },
  },
  mounted() {
    this.fetchCountries()
  },
  computed: {
    ...mapState({
      loading: (state) => state.typeSubscriptions.loading,
      selected: (state) => state.typeSubscriptions.selected,
      pagination: (state) => state.typeSubscriptions.pagination,
      filters: (state) => state.typeSubscriptions.filters,
    }),
    ...mapGetters({
      formatedList: 'typeSubscriptions/formatedList',
    }),
    headers() {
      return [
        {
          text: this.$t('fields.global.actions'),
          align: 'center',
          sortable: false,
        },
        {
          text: this.$t('fields.global.state'),
          align: 'center',
          value: 'active',
        },
        {
          text: this.$t('fields.global.name'),
          value: 'name',
        },
        {
          text: this.$t('fields.typeSubscriptions.availableMatches'),
          value: 'availableMatches',
          sortable: false,
        },
        {
          text: this.$tc('fields.typeSubscriptions.typePayment', 2),
          value: 'typePayment',
          sortable: false,
        },
        {
          text: this.$t('fields.typeSubscriptions.storage'),
          align: 'center',
          value: 'storage',
        },
        {
          text: this.$t('fields.global.createdAt'),
          align: 'center',
          value: 'createdAt',
        },
        {
          text: this.$t('fields.global.createdBy'),
          align: 'center',
          value: 'createdBy',
        },
        {
          text: this.$t('titles.global.updates'),
          align: 'center',
          sortable: false,
        },
      ]
    },
    localPagination: {
      get() {
        return this.pagination
      },
      set(value) {
        this.$store.commit('typeSubscriptions/setPagination', value)
      },
    },
    localFilters: {
      get() {
        return this.filters
      },
      set(value) {
        this.$store.commit('typeSubscriptions/setFilters', value)
      },
    },
  },
  methods: {
    ...mapActions({
      fetchOne: 'typeSubscriptions/fetchOne',
      setCreate: 'typeSubscriptions/create',
      setDelete: 'typeSubscriptions/delete',
      reset: 'typeSubscriptions/reset',
      fetchList: 'typeSubscriptions/fetchList',
    }),
    fetchCountries() {
      apiAxios.post(`countries/select?limit=0`).then((response) => {
        this.countriesList = response.data.data.country
        // console.log(this.countriesList)
      })
    },
    country(id) {
      return this.countriesList.find((country) => country.value === id)
    },
    setOne(id) {
      this.$emit('clear')
      this.fetchOne(id).then(() => this.$emit('form'))
    },
    setNew() {
      this.$emit('clear')
      this.$emit('form')
    },
    openUpdated(id) {
      this.$emit('clear')
      this.fetchOne(id).then(() => (this.dialogUpdated = true))
    },
    ifDelete(id) {
      this.idDelete = id
      this.dialogDelete = true
    },
    _setDelete(id) {
      this.setDelete(id).finally(() => (this.dialogDelete = false))
    },
    // debounceFetch: debounce(function() {
    //   this.fetchList({
    //     match: this.search
    //   })
    // }, 1000)
  },
}
</script>
